export default "__VITE_ASSET__ByuSOEqR__"